import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { getAllInstruments } from '!core/redux/userInstruments/userInstruments.selectors';
import { handleSagaError } from '»utils/handleSagasError';
import { getTopInstrumentSubStrLabel } from '»utils/string';

import { trlTopInstrumentsServices } from './trlTopInstruments.services';
import { trlTopInstrumentsSlice } from './trlTopInstruments.slice';

const instrumentsTopGroupsWorker = function* ({ payload }) {
  try {
    const instrumentsTopGroups = yield call(
      trlTopInstrumentsServices.wsbGetInstrGroupsWithTops,
    );

    const formattedInstrTopGroups = instrumentsTopGroups.reduce((acc, item) => {
      const instrTopGroupDescr = payload.isDesktop
        ? item.descr
        : getTopInstrumentSubStrLabel(item.descr);

      acc.push({ value: item.instrumentGroup, label: instrTopGroupDescr });

      return acc;
    }, []);

    yield all([
      put(
        trlTopInstrumentsSlice.actions.selectInstrTopGroup({
          instrumentTopGroup: formattedInstrTopGroups[0].value,
        }),
      ),
      put(
        trlTopInstrumentsSlice.actions.instrumentsTopGroupsSucess(
          formattedInstrTopGroups,
        ),
      ),
    ]);
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled)
      yield put(trlTopInstrumentsSlice.actions.instrumentsTopGroupsFailure());
  }
};

const topInstrumentsWorker = function* ({ payload }) {
  try {
    const userInstrumentsData = yield select(getAllInstruments);

    const topInstruments = yield call(
      trlTopInstrumentsServices.wsbGetTopQuotes,
      {
        instrumentTopGroup: payload.instrumentTopGroup,
      },
    );

    const completedTopInstrumentsInfo = topInstruments.map((topInstr) => {
      const topInstrDescr = userInstrumentsData.find(
        (userInstr) =>
          userInstr.symbol === topInstr.symbol &&
          userInstr.securityType === topInstr.securityType &&
          userInstr.exchange === topInstr.exchangeId,
      )?.descr;

      topInstr.descr = topInstrDescr;

      return topInstr;
    });

    yield put(
      trlTopInstrumentsSlice.actions.topInstrumentsSucess(
        completedTopInstrumentsInfo,
      ),
    );
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled)
      yield put(trlTopInstrumentsSlice.actions.topInstrumentsFailure());
  }
};

export const trlTopInstrumentsSagas = function* () {
  yield takeLatest(
    trlTopInstrumentsSlice.actions.instrumentsTopGroupsRequest.type,
    instrumentsTopGroupsWorker,
  );
  yield takeLatest(
    [
      trlTopInstrumentsSlice.actions.topInstrumentsRequest.type,
      trlTopInstrumentsSlice.actions.selectInstrTopGroup.type,
    ],
    topInstrumentsWorker,
  );
};
